import classNames from 'classnames';
import isPromise from 'is-promise';
import isNil from 'lodash/isNil';
import isFunction from 'lodash/isFunction';
import assignWith from 'lodash/assignWith';
import { global } from 'choerodon-ui/shared';
if (!global.FUNCTION_CHAINS_MAP) {
    global.FUNCTION_CHAINS_MAP = new WeakMap();
}
const chainsMap = global.FUNCTION_CHAINS_MAP;
function merge(prop, other) {
    if (isNil(prop)) {
        return other;
    }
    if (isNil(other)) {
        return prop;
    }
    return {
        ...prop,
        ...other,
    };
}
function customizer(value, srcValue, key) {
    if (key === 'style' || key.endsWith('Style')) {
        return merge(value, srcValue);
    }
    if (key === 'className' || key.endsWith('ClassName')) {
        return classNames(value, srcValue);
    }
    if (key.endsWith('Props')) {
        return mergeProps(value, srcValue);
    }
    if (isFunction(value) && isFunction(srcValue)) {
        const chains = chainsMap.get(value);
        if (chains) {
            chains.fn = srcValue;
            return chains;
        }
        const newChains = function (...args) {
            const $chains = chainsMap.get(value);
            const { fn } = $chains || {};
            if (fn) {
                const ret = fn(...args);
                if (isPromise(ret)) {
                    return ret.then(result => {
                        if (result !== false) {
                            return value(...args);
                        }
                        return result;
                    });
                }
                if (ret === false) {
                    return false;
                }
            }
            return value(...args);
        };
        newChains.fn = srcValue;
        chainsMap.set(value, newChains);
        return newChains;
    }
}
export default function mergeProps(props, otherProps) {
    if (isNil(props)) {
        return otherProps;
    }
    if (isNil(otherProps)) {
        return props;
    }
    return assignWith(props, otherProps, customizer);
}
